import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NxSpinnerModule } from '@allianz/ng-aquila/spinner';

@Component({
  selector: 'app-callback',
  imports: [NxSpinnerModule],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss'
})
export class CallbackComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);

  ngOnInit(): void {
    window.top?.postMessage({
      message_type: '3DS-authentication-complete',
      data: this.activatedRoute.snapshot.queryParams
    });
  }
}
